<template>
  <div class="checkout-section-inner">
    <div class="form-group">
      <label for="payment-method" class="control-label">Payment method</label>
      <select id="payment-method" v-model="paymentMethod" class="form-control">
        <option value="credit_card" v-if="this.allowedMethods.credit_card_enabled">Credit Card</option>
        <option value="invoice" v-if="this.allowedMethods.invoice_enabled">Invoice</option>
        <option value="pay_on_collection" v-if="this.allowedMethods.collection_payment_enabled">Pay on collection</option>
      </select>
    </div>

      <div v-if="this.paymentMethod == 'invoice'">
        <div class="checkout-note-box" v-if="checkoutPreferences.allowed_payment_methods.friendly_invoice_terms.length">
          <strong>Invoice Terms</strong><br>
          <p><span>{{checkoutPreferences.allowed_payment_methods.friendly_invoice_terms}}</span></p>
        </div>

        <form v-on:submit.prevent="">
          <div class="form-group">
            <div class="checkboxes">
              <label>
                <input type="checkbox" id="invoice-agreed" v-model="invoiceAgreed">
                <span> I am authorised to proceed with this transaction by my company</span>
              </label>
            </div>
          </div>
        </form>
      </div>

      <div v-if="this.paymentMethod == 'credit_card'">
        <stripe
            user-is-partner="false"
            :hide-title=true
            payment-button-class="btn btn-primary"
            :hide-summary=true
            :price="grandTotal"
            :api-key="stripeApiKey"
            :stripe-account-id="stripeAccountId"
            :stored-payment-methods="{}"
            :payment-intent-create-path=paymentIntentPath
            @paymentComplete="completeStripeCheckout"
            :purchase-params={}></stripe>
      </div>

    <button type="submit" v-if="this.paymentMethod != 'credit_card'"  id="complete-order" class="btn btn-primary" v-on:click="completeInvoiceCheckout" :disabled="(this.paymentMethod == 'invoice' && !this.invoiceAgreed) ? true : false">
      <i class="fas fa-arrow-circle-right"></i>
      Next
    </button>
  </div>
</template>
<script>
import { createOrder, generatePaymentIntentpath } from "../../../shopfront/cartDataService";
import stripe from '../../../components/stripe';
export default {
  components: { stripe },
  props: {
    cartPid: String,
    grandTotal: { type: String, required: true },
    allowedMethods: Object,
    stripeApiKey: { required: false, type: String },
    checkoutPreferences: { required: true, type: Object},
    stripeAccountId: { required: false, type: String},
  },
  data() {
    return {
      paymentMethod: 'credit_card',
      invoiceAgreed: false,
    };
  },
  methods: {
    completeStripeCheckout: function(orderNumber) {
      this.$store.dispatch('orderComplete');
      this.$router.push({ name: 'complete', query: { ref: orderNumber} });
    },
    completeInvoiceCheckout: function() {
      let vm = this;
      createOrder(this.cartPid, this.sellerPid, this.paymentMethod, function(orderNumber) {
        vm.$store.dispatch('orderComplete');
        vm.$router.push({ name: 'complete', query: { ref: orderNumber} });
      });
    },
  },
  computed: {
    paymentIntentPath() {
      return generatePaymentIntentpath(this.cartPid, this.sellerPid);
    },
    sellerPid() {
      return this.$store.state.sellerPid;
    },
  },
};
</script>
